<template>
    <div
        class="Home"
        :class="{ 'Home--desktop': !isMobile }">
        <div class="Home-buttonWrapper">
            <ul class="SilicOneBrochures">
                <li><a
                    title="Hempel_Y_SilicOne_Brochure_CRO"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_CRO.pdf?v=2">Hempel_Y_SilicOne_Brochure_CRO.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_DE"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_DE.pdf?v=2">Hempel_Y_SilicOne_Brochure_DE.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_DK"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_DK.pdf?v=2">Hempel_Y_SilicOne_Brochure_DK.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_ES"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_ES.pdf?v=2">Hempel_Y_SilicOne_Brochure_ES.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_FI"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_FI.pdf?v=2">Hempel_Y_SilicOne_Brochure_FI.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_FR"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_FR.pdf?v=2">Hempel_Y_SilicOne_Brochure_FR.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_NL"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_NL.pdf?v=2">Hempel_Y_SilicOne_Brochure_NL.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_NO"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_NO.pdf?v=2">Hempel_Y_SilicOne_Brochure_NO.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_SE"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_SE.pdf?v=2">Hempel_Y_SilicOne_Brochure_SE.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_UK"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_UK.pdf?v=2">Hempel_Y_SilicOne_Brochure_UK.pdf</a></li>

                <li><a
                    title="Hempel_Y_SilicOne_Brochure_US"
                    target="_blank"
                    href="/Hempel_Y_SilicOne_Brochure_US.pdf?v=2">Hempel_Y_SilicOne_Brochure_US.pdf</a></li>

            </ul>
        </div>

    </div>
</template>
<script>
import HempelButton from '@/components/shared/button/Button'

export default {
    name: 'Manuals',
    components: {
        HempelButton
    },
    computed: {
        title() {
            return this.translation.home.title
        },
        copy() {
            return this.translation.home.subtitle
        },
        find() {
            return this.translation.home.findProduct
        },
        calculate() {
            return this.translation.home.calculateVolume
        }
    },
    mounted() {
        const cookies = document.createElement('script')
        cookies.setAttribute('src', 'https://consent.cookiebot.com/uc.js')
        cookies.setAttribute('id', 'Cookiebot')
        cookies.setAttribute('data-cbid', 'bf5aac4a-93b9-4b4d-b40a-b04a78c36b5e')
        cookies.setAttribute('data-blockingmode', 'auto')
        cookies.setAttribute('type', 'text/javascript')
        document.head.appendChild(cookies)
    }
}
</script>
